const AbstractDojoRequestRecord = require('./AbstractDojoRequestRecord');
const DojoConfig = require('../../DojoConfig');

class DojoTerminalDetailsRequestRecord extends AbstractDojoRequestRecord {
    /**
     * @param {DojoConfig} config
     */
    constructor(config) {
        if (!(config instanceof DojoConfig)) {
            throw new Error('Required instance of DojoConfig is missing');
        }
        const url = 'pac/terminals/' + config.terminalId;
        super(
            'GET',
            url
        );
    }
}

module.exports = DojoTerminalDetailsRequestRecord;
